@if (browserSupported) {
  <div [class]="'flex-col ' + (currentComponentFullScreen ? 'main-container-full' : 'main-container-flow')" lang="de">
    @if (app.showTopbar) {
      <app-topbar></app-topbar>
    }
    @if (app.breadcrumbsVisible && !app.breadcrumbsInToolBar && !app.showSpinner) {
      <p-breadcrumb class="breadcrumbs" [home]="app.breadcrumbsHome" [model]="app.breadcrumbsItems" [style]="{background: 'white', border: '0px', padding: '1rem 1.5rem 0.5rem 1.5rem'}"></p-breadcrumb>
    }
    <div class="flex-item-fill flex-row">
      @if (app.showSidebar) {
        <app-sidebar></app-sidebar>
      }
      <div class="flex-item-fill height100p flex-col overflow-x-auto overflow-y-auto" [class.p-2]="app.showTopbar || app.showSidebar" [class.layout-spinner]="app.showSpinner">
        <div class="flex-item-fill" [style.overflowY]="'unset'" [class.hidden]="app.showSpinner">
            <router-outlet></router-outlet>
        </div>
        @if (app.showSpinner) {
          <div class="overlay">
            <div class="spinner-wrapper">
              <p-progressSpinner class="spinner"></p-progressSpinner>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  @if (privacyPolicy && !privacyPolicyAccepted) {
    <p-dialog header="Datenschutzerklärung" [visible]="!privacyPolicyAccepted" [modal]=true [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}"
      [draggable]=false [resizable]=false [closable]=false>
      <div innerHtml="{{privacyPolicyHtml}}"></div>
      <ng-template pTemplate="footer">
        <p-button icon="fas fa-times" (click)="declinePrivacyPolicy()" label="Ablehnen und ausloggen" styleClass="p-button-text"></p-button>
        <p-button icon="fas fa-check" (click)="acceptPrivacyPolicy()" label="Akzeptieren" styleClass="p-button-text"></p-button>
      </ng-template>
    </p-dialog>
  }
}
@else {
<div class="centered-message">
  <h1>Sie verwenden einen nicht unterstützten Browser.</h1>
  <p>Diese Anwendung unterstützt Chrome, Firefox, Edge und Safari</p>
</div>
}
<p-toast key="top" position="top-center"></p-toast>
<p-toast key="notification" position="bottom-right" (onClose)="toastClosed($event)"></p-toast>
<div class="css-debug-message">
    @if (debugMessageText != null) {
        <p-message severity="info" [innerHTML]="debugMessageText"></p-message>
    }
</div>
<p-confirmpopup></p-confirmpopup>
<div #confirmPopupTarget style="position: absolute; width: 1px; height: 1px; pointer-events: none;"></div>
@if (app.storedErrors.length > 0) {
  <p-avatar class="bug-icon mr-2" icon="fas fa-bug" shape="circle" [pTooltip]="app.storedErrors[0]" tooltipPosition="top" (click)="app.storedErrors = []"></p-avatar>
}
<p-contextMenu #cm [class]="app.contextMenuClass" [model]="app.contextMenu" [style.width]="'500px'" [appendTo]="'body'"></p-contextMenu>
